<script>
    export let href = null
    export let alt = ''
    export let label = ''
    export let disabled = false
    export let style = ''
    import { createEventDispatcher } from 'svelte'
    const dispatch = createEventDispatcher()
    function mousedown() {
        dispatch('mousedown', {})
    }
    function mouseup() {
        dispatch('mouseup', {})
    }
    function mouseover() {
        dispatch('mouseover', {})
    }
    function mouseout() {
        dispatch('mouseout', {})
    }
    function dblclick() {
        dispatch('dblclick', {})
    }
    function click() {
        dispatch('click', {})
    }
    function contextmenu() {
        dispatch('contextmenu', {})
    }
</script>

<a
    {href}
    {alt}
    {style}
    on:click={disabled ? (_) => {} : click}
    on:dblclick={disabled ? (_) => {} : dblclick}
    on:mousedown={disabled ? (_) => {} : mousedown}
    on:mouseup={disabled ? (_) => {} : mouseup}
    on:mouseover={disabled ? (_) => {} : mouseover}
    on:mouseout={disabled ? (_) => {} : mouseout}
    on:contextmenu={disabled ? (_) => {} : contextmenu}
    on:focus={(_) => _}
    on:blur={(_) => _}
>
    {#if label}
        {label}
    {:else}
        <slot />
    {/if}
</a>

<style>
    a,
    a:hover,
    a:visited,
    a:active,
    a:active {
        color: var(--color-brand-primary-01);
        text-decoration: underline;
        cursor: pointer;
    }
</style>
